export const FooterUrls: Record<string, string> = {
    lystInsights: "https://www.lyst.com/data/",
    lystNews: "https://www.lyst.com/news/",
    lystEditorial: "https://www.lyst.com/editorial/",
    makingLyst: "https://making.lyst.com/",
};
